import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Form } from '@unform/web';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Autocomplete, Combobox, InputText } from '~/components/Form';
import { t } from '~/helpers';
import { storeOperacaoMedicaoTemperatura } from '~/store/modules/operacaomedicaotemperatura/actions';

export default function CreateOrUpdate({
  reference,
  data,
  create,
  toggleLoading,
}) {
  const dispatch = useDispatch();

  const [posto, setPosto] = useState(0);

  const [tanqueVirtual, setTanqueVirtual] = useState(0);

  const handleGetPosto = React.useCallback((id, type) => {
    setPosto(id);
  }, []);

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.operacaomedicaotemperatura
  );
  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        idposto: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        idtanquevirtual: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        idtanquefisico: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        temperaturamediamedicaotemperatura: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .transform((value) => (isNaN(value) ? undefined : value))
          // .integer(t('s.geral.validacao.deveserinteiro'))
          .moreThan(-1, t('s.geral.validacao.valorminimo').replace('%s', 0))
          .lessThan(101, t('s.geral.validacao.valormaximo').replace('%s', 100))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
      });

      let { temperaturamediamedicaotemperatura } = param;

      if (temperaturamediamedicaotemperatura) {
        temperaturamediamedicaotemperatura = String(
          temperaturamediamedicaotemperatura
        ).replace(',', '.');
      }

      const objParam = {
        ...param,
        temperaturamediamedicaotemperatura,
      };

      await schema.validate(objParam, {
        abortEarly: false,
      });

      const objSend = {
        idmedicaotemperatura: 0,
        idcliente: client,
        idposto: objParam.idposto,
        idtanquevirtual: objParam.idtanquevirtual,
        idtanquefisico: objParam.idtanquefisico,
        idusuario: 0,
        datahorainiciomedicaotemperatura: null,
        datahorafinalmedicaotemperatura: null,
        temperaturamediamedicaotemperatura: Number(
          objParam.temperaturamediamedicaotemperatura
        ),
      };

      dispatch(storeOperacaoMedicaoTemperatura(objSend, params));
    } catch (err) {
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Autocomplete
            name="idposto"
            label="codigonomeposto"
            url="postoscomboioscontrole20graus"
            unique="idposto"
            title={t('s.geral.postocomboio')}
            disabled={!create}
            getValue={({ idposto, tipoposto }) =>
              handleGetPosto(idposto, tipoposto)
            }
          />
          <Combobox
            name="idtanquevirtual"
            label="tanquevirtualprodutotanquevirtual"
            url="tanquesvirtuais"
            unique="idtanquevirtual"
            title={t('s.configuracao.tanquefisico.idtanquevirtual')}
            disabled={!posto || !create}
            params={{
              wherefield: ['idposto', 'tipoproduto'],
              valuewherefield: [!isEmpty(find) ? find.idposto : posto, 'C'],
              typewherefield: ['EQUALS', 'EQUALS'],
            }}
            getValue={(value) =>
              value.idtanquevirtual && setTanqueVirtual(value.idtanquevirtual)
            }
          />
          <Combobox
            name="idtanquefisico"
            disabled={!create || !posto || !tanqueVirtual}
            label="codigotanquefisico"
            url="tanquesfisicos"
            unique="idtanquefisico"
            title={t('s.configuracao.tanquefisico.idtanquefisico')}
            // hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
            params={{
              wherefield: ['idposto', 'idtanquevirtual'],
              valuewherefield: [
                !isEmpty(find) ? find.idposto : posto,
                tanqueVirtual,
              ],
              typewherefield: ['EQUALS', 'EQUALS'],
              fieldlist:
                'idposto, idtanquevirtual, idtanquefisico, codigotanquefisico',
            }}
          />

          <InputText
            name="temperaturamediamedicaotemperatura"
            label={t('s.operacao.medicaotemperatura.temperaturamedia')}
            mask="99,9"
            placeholder=""
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
